export default __webpack_public_path__ + "static/media/scheduler.1e1682c4.png";